'use client'

import {
  ImageCard,
  OpeningTitle,
  Paragraph,
  Section,
  Title,
} from '@dynamo-caffeina-dev/airc-ui-kit'

import {
  ImageCardProps,
  NormalizedSection,
  OpeningTitleProps,
  ParagraphProps,
  TitleProps,
} from '@/types'

import Slider from '@/components/molecules/Slider'
import { dispatchGTMEvent } from '@/lib/tracking/gtm'
import { GTM_EVENT_CATEGORY } from '@/lib/tracking/types'

export interface SlideContent {
  content: {
    title: string
    body: string
    cta: {
      content: {
        label: string
        href: string
        target?: string
      }
    }
    image: ImageCardProps['image']
  }
}

export interface VideoSliderProps extends NormalizedSection {
  modelledContent: {
    openingTitle: OpeningTitleProps
    title: TitleProps
    paragraph: ParagraphProps
    slides: SlideContent[]
  }
}

const VideoSlider = ({ modelledContent }: VideoSliderProps) => {
  const { openingTitle, title, paragraph, slides } = modelledContent
  return (
    <Section className='section-video-slider'>
      <div className='section-video-slider__header'>
        <div className='section-intro'>
          <OpeningTitle {...openingTitle}>{openingTitle.content}</OpeningTitle>
          <Title
            {...title}
            dangerouslySetInnerHTML={{ __html: title.content || '' }}
          />
        </div>
        <div className='section-abstract'>
          <Paragraph
            as={'div'}
            {...paragraph}
            dangerouslySetInnerHTML={{ __html: paragraph?.content || '' }}
          />
        </div>
      </div>
      <div className='section-video-slider__items'>
        <Slider
          slides={slides.map(({ content }, i) => {
            const { title, body, cta, image } = content

            return (
              <div
                key={'ImageCard__' + i}
                style={{ paddingBottom: 'var(--Spacing-M)' }}
              >
                <ImageCard
                  className={'DonorStoriesSection__image-card'}
                  title={title ?? ''}
                  body={body ?? ''}
                  cta={{
                    label: cta.content.label,
                    href: cta.content.href,
                    target: cta.content.target || '_blank',
                    rel: 'noopener noreferrer',
                  }}
                  image={image}
                  linkProps={{
                    // @ts-ignore
                    onClick() {
                      dispatchGTMEvent(GTM_EVENT_CATEGORY.VIDEO_CLICK, {
                        section: `Titolo: "${title}"; Descrizione: "${body}"`,
                      })
                    },
                  }}
                />
              </div>
            )
          })}
        />
      </div>
    </Section>
  )
}

export default VideoSlider
